import { useMemo } from 'react';

interface UseImgixConfig {
  removeSegments?: string | string[];
  imgix?: {
    fit?: 'crop' | 'clip';
    width?: number;
    height?: number;
  };
}

export function useImgix(src?: string, { removeSegments = ['developertool'], imgix = {} }: UseImgixConfig = {}) {
  const removeSegmentsArray = Array.isArray(removeSegments) ? removeSegments : [removeSegments];
  const { fit = 'crop', width, height } = imgix;

  return useMemo(() => {
    if (!src) {
      return { src: undefined };
    }

    const srcUrl = new URL(src);

    srcUrl.pathname = srcUrl.pathname
      .split('/')
      .filter((segment) => !removeSegmentsArray.includes(segment))
      .join('/');

    const url = new URL(srcUrl.pathname, `https://travprocdn.imgix.net`);

    url.searchParams.set('fit', fit);

    if (width ?? height) {
      url.searchParams.set('w', width === undefined && height !== undefined ? 'auto' : (width?.toString() ?? 'auto'));
      url.searchParams.set('h', height === undefined && width !== undefined ? 'auto' : (height?.toString() ?? 'auto'));
    }

    return { src: url.toString() };
  }, [src, removeSegmentsArray]);
}
